import {useMemo} from "react";
import {theme} from "antd";
import type {ConfigProviderProps} from "antd";

export default function useGlassTheme(currentTheme: "light" | "dark"): ConfigProviderProps["theme"] {
    const {darkAlgorithm, defaultAlgorithm} = theme;

    return useMemo(() => ({
        token: {
            colorPrimary: "#00e5ff",
            colorInfo: "#00e5ff",
            colorLink: "#00e5ff",
            wireframe: false,
            ...(currentTheme === "dark" ? {
                colorBgBase: "#000e10",
                colorBgContainer: "#001315"
            } : {})
        },
        components: {
            Button: {
                colorPrimary: currentTheme === "light" ? "#001315" : undefined,
            },
            Card: {
                lineType: "",
            },
            Layout: (currentTheme === "dark" ? {

                headerBg: "#001315",
                siderBg: "#001315"

            } : {
                headerBg: "#ffffff",
                siderBg: '#ffffff'
            }),
            Menu: {
                colorSplit: "rgba(0,0,0,0)"
            }

        },
        algorithm: currentTheme === "light" ? defaultAlgorithm : darkAlgorithm,
    }), [currentTheme, darkAlgorithm, defaultAlgorithm]);
}


